import { render, staticRenderFns } from "./OrbitRejectedByTheUserStep.vue?vue&type=template&id=0fa095d8"
import script from "./OrbitRejectedByTheUserStep.vue?vue&type=script&lang=ts"
export * from "./OrbitRejectedByTheUserStep.vue?vue&type=script&lang=ts"
import style0 from "./OrbitRejectedByTheUserStep.vue?vue&type=style&index=0&id=0fa095d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports